module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-2-Article.69f9da95.webp";